import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getSubjects } from "../ApiService/ApiService";

export const fetchSubjectsAsync = createAsyncThunk(
  "subjects/fetchSubjects",
  async () => {
    const response = await getSubjects();
    return response.data;
  }
);

const initialState = {
  subjects: [],
  loading: false,
  error: null,
};

export const subjectsSlices = createSlice({
  name: "subjects",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubjectsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSubjectsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.subjects = action.payload;
      })
      .addCase(fetchSubjectsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const selectAllSubjects = (state) => state.subjects.subjects;
export const selectSubjectsLoading = (state) => state.subjects.loading;
export const selectSubjectsError = (state) => state.subjects.error;

export default subjectsSlices.reducer;
